import React, { useState, useEffect } from 'react';
import {
    Form,
    Input,
    Select,
    Row,
    Col,
    Button,
    Space,
    Modal,
    DatePicker,
} from 'antd';
import { apiRequest } from '../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../components/errorHandler';

const { TextArea } = Input;
const { Option } = Select;


interface RackNumberModelProps {
    visible: boolean;
    onCancel: () => void;
    onCreate: (data: any) => void; // Callback after successful submit
    initialValues?: {
        rack_id?: number;
        rack_name?: string;
        rack_number?: string;
    } | null;
    isEditMode?: boolean;
}

const RackNumberModel: React.FC<RackNumberModelProps> = ({
    visible,
    onCancel,
    onCreate,
    initialValues = null,
    isEditMode = false,
}) => {
    const [form] = Form.useForm();
    const [isModalClose, setIsModalClose] = useState(true);

    // Determine if submit button should be disabled based on form validation
    const isSubmitDisabled = () => {
        const errors = form.getFieldsError();
        return errors.some(({ errors }) => errors.length > 0);
    };


    // Handle form submit
    const handleAddRackNumber = async (values: any) => {
        try {
            const dataVal = {
                rack_name: values.rack_name,
                rack_number: values.rack_number,
                ...(initialValues?.rack_id && { rack_id: initialValues.rack_id }),
            };
            const url = isEditMode
                ? 'edit-rack'
                : 'add-rack';

            const method = isEditMode ? 'put' : 'post';

            const data = await apiRequest({
                method,
                url,
                data: dataVal,
            });
            console.log(dataVal);

            onCreate(data); // Notify parent about success
            showSuccess(
                isEditMode ? 'rack updated successfully!' : ' rack created successfully!',
            );
            form.resetFields();

            if (isModalClose) {
                onCancel(); // Close modal only if Submit button was clicked (not Submit & Create New)
            }
        } catch (error) {
            showError(`Failed to ${isEditMode ? 'update' : 'create'} rack`);
        }
    };

    // When modal opens or mode changes, set/reset form fields accordingly
    useEffect(() => {
        if (visible && isEditMode && initialValues) {
            form.setFieldsValue({
                rack_name: initialValues.rack_name,
                rack_number: initialValues.rack_number,
            });
        } else if (visible) {
            form.resetFields();
        }
    }, [visible, isEditMode, initialValues, form]);




    return (
        <Modal
            title={isEditMode ? 'Edit rack number' : 'Add New rack number'}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width="90%"
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleAddRackNumber}
                autoComplete="off"
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="rack_name"
                            className='px-8'
                            label={
                                <span>
                                    Rack Name&nbsp;
                                    <span style={{ fontSize: '12px', color: '#888' }}>
                                        (Max 50 characters)
                                    </span>
                                </span>
                            }
                            rules={[
                                { required: true, message: 'Please enter the Rack Number' },
                                { max: 50, message: 'Maximum 255 characters allowed' },
                            ]}
                        >
                            <Input
                                showCount
                                maxLength={50}
                                placeholder="e.g., Rack Number "

                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="rack_number"
                            className='px-8'
                            label={
                                <span>
                                    Rack Number&nbsp;
                                    <span style={{ fontSize: '12px', color: '#888' }}>
                                        (Max 255 characters)
                                    </span>
                                </span>
                            }
                            rules={[
                                { required: true, message: 'Please enter the Rack Number' },
                                { max: 255, message: 'Maximum 255 characters allowed' },
                            ]}
                        >
                            <Input
                                showCount
                                maxLength={255}
                                placeholder="e.g., Rack Number "

                            />
                        </Form.Item>
                    </Col>
                </Row>


                <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Space>
                        <Button onClick={onCancel}>Cancel</Button>
                        {!isEditMode && <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(false)}
                            disabled={isSubmitDisabled()}
                        >
                            Submit & Create New Rack Number
                        </Button>}
                        <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(true)}
                            disabled={isSubmitDisabled()}
                        >
                            Submit
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default RackNumberModel;
